import { GlobalContext } from "@/context/GlobalContext";
import { useContext } from "preact/hooks";

export function useToggleSideCart() {
	const { sideCartOpen, setSideCartOpen } = useContext(GlobalContext);

	function toggleSideCart() {
		setSideCartOpen(!sideCartOpen);
	}

	return toggleSideCart;
}
